export { default } from './Div';



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Div/index.js
 **/